import React from "react";
import PropTypes from "prop-types";
import StyleCount from "../StyleCount";
import LoadPreviousButton from "./LoadPreviousButton";

const ResultsHeader = ({ showLoadPrevious, itemCount }) =>
  showLoadPrevious ? (
    <LoadPreviousButton />
  ) : (
    <StyleCount itemCount={itemCount} />
  );

ResultsHeader.propTypes = {
  itemCount: PropTypes.number.isRequired,
  showLoadPrevious: PropTypes.bool.isRequired
};

export default ResultsHeader;
